import { render, staticRenderFns } from "./config.vue?vue&type=template&id=04485e45&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=04485e45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04485e45",
  null
  
)

export default component.exports